import { useNavigate } from 'react-router-dom'
import { useAppMutation } from '@/helpers/api/mutation'

import { useModal } from '@/components/Modal'
import { createAuthInstance } from '@/helpers/api/base'
import { ROUTES } from '@/router/routes'
import { useAuthStore } from '@/store/auth-store'
import { msalInstance } from '../config/authConfig'

export const useUserLogout = () => {
    const { closeModal } = useModal()
    const { clear } = useAuthStore()
    const navigate = useNavigate()

    return useAppMutation({
        mutationFn: () =>
            createAuthInstance({
                url: '/Logout',
                method: 'POST',
            }),

        onSettled: () => {
            msalInstance.clearCache()
            clear()
            closeModal()
            navigate(ROUTES.LOGIN)
        },
    })
}
